import * as Reflux from "reflux";
export const CartRecommendationActions = {
	addItem: Reflux.createAction(["addItem"]),
	removeItem: Reflux.createAction(["removeItem"]),
	closeRecommendation: Reflux.createAction(["closeRecommendation"]),
	onRecommendationShown: Reflux.createAction(["onRecommendationShown"])
};
